import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';
import { tabToggleList } from './utils';

export default class ListItem extends BaseExtension {
  protected _schema: NodeSpec = {
    attrs: {
      id: { default: null },
    },
    content: 'paragraph block*',
    defining: true,
    parseDOM: [{ tag: 'li' }],
    toDOM: (node) => [
      'li',
      { class: 'ms-20 body-long-01 text-text-paragraph', id: node.attrs.id },
      0,
    ],
  };

  get schema(): NodeSpec {
    return this._schema;
  }

  get keys() {
    return { Tab: tabToggleList };
  }

  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  plugins = plugins;
}
